const SIZE_MAP = {
  small: 25,
  medium: 35,
  large: 50
}

export default ({ fillColor = '#F6F6F6', strokeColor = '#DCDCDC', style = {}, size = 'large' }) => {
  const pixelSize = SIZE_MAP[size] || SIZE_MAP.large
  return (
    <svg
      width={pixelSize}
      height={pixelSize}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <circle cx="10.999" cy="10.999" r="9.99902" fill={fillColor} stroke={strokeColor} strokeWidth="0.83332" />
      <path d="M10.998 2.49982V4.99967" stroke={strokeColor} strokeWidth="0.83332" />
      <path d="M10.998 16.9984V19.4982" stroke={strokeColor} strokeWidth="0.83332" />
      <path d="M15.248 3.63892L14.4981 4.93788" stroke={strokeColor} strokeWidth="0.83332" />
      <path d="M7.49609 17.0609L6.74614 18.3598" stroke={strokeColor} strokeWidth="0.83332" />
      <path d="M18.3594 6.74933L17.0604 7.49929" stroke={strokeColor} strokeWidth="0.83332" />
      <path d="M4.9375 14.4987L3.63854 15.2486" stroke={strokeColor} strokeWidth="0.83332" />
      <path d="M18.3594 15.2487L17.0604 14.4988" stroke={strokeColor} strokeWidth="0.83332" />
      <path d="M4.9375 7.49939L3.63854 6.74943" stroke={strokeColor} strokeWidth="0.83332" />
      <path d="M6.75 3.63861L7.49996 4.93757" stroke={strokeColor} strokeWidth="0.83332" />
      <path d="M14.5 17.0606L15.25 18.3596" stroke={strokeColor} strokeWidth="0.83332" />
      <path d="M19.5 10.999L17.0001 10.999" stroke={strokeColor} strokeWidth="0.83332" />
      <path d="M5 10.999L2.50014 10.999" stroke={strokeColor} strokeWidth="0.83332" />
      <path d="M11 6.24957V10.9993L13.4999 13.4992" stroke={strokeColor} strokeWidth="0.83332" />
    </svg>
  )
}
